import { render } from "./ReleaseNotesUpdate.vue?vue&type=template&id=48abea31&scoped=true"
import script from "./ReleaseNotesUpdate.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesUpdate.vue?vue&type=script&lang=js"

import "./ReleaseNotesUpdate.vue?vue&type=style&index=0&id=48abea31&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48abea31"]])

export default __exports__